module.exports = __webpack_public_path__ + "media/img/logos/praxisklinik-winterhude-97417b6f2b4ab586a0ddd282468fdf4b.png";